import React from "react";
import Navbar from "components/BreakfastEvent/Navbar";
import Footer from "components/sections/home/HomeFooter";
import HeroSection from "components/DesktopResearch/HeroSection";
import ReasonForResearch from "components/DesktopResearch/ReasonForResearch";
import ResearchExplore from "components/DesktopResearch/ResearchExplore";
import LsatSection from "components/DesktopResearch/LsatSection";
import EcoSystemSection from "components/DesktopResearch/EcoSystemSection";

const DesktopResearch = () => {
  return (
    <div className="bg-[#FFF4E3] relative">
      <Navbar />
      <HeroSection />
      <ReasonForResearch />
      <ResearchExplore />
      <EcoSystemSection />
      <LsatSection />
      <Footer />
    </div>
  );
};

export default DesktopResearch;
